import {CALENDARDATAS_EMPTY, useCalendarDataMutations} from "../../api/calendardatasapi";
import {useCallback, useState} from "react";
import {useForm} from "../../utilities/formutilities";
import {Button, Col, Form, FormControl, FormLabel, FormSelect} from "react-bootstrap";
import {Section} from "../grouping/Section";
import {CustomEditor} from "../CustomEditor";
import {useCalendarTypes} from "../../api/calendarypes";
import {ButtonLoading} from "../ButtonLoading";

export function CalendarTaskForm(props) {
    const {onOpenChanged, taskEditing} = props;
    const [loading, setIsLoading] = useState(false);
    const {createCalendarData, editCalendarData} = useCalendarDataMutations();
    const {calendartypes} = useCalendarTypes();

    const initialObjectInitializer = useCallback(() => taskEditing ?
        {
            ...taskEditing, date: taskEditing.date.substring(0, 10)
        } :
        {...CALENDARDATAS_EMPTY, date: new Date().toISOString().substring(0, 10)}, []);
    const {onChange, tempObject, onEditorChange} = useForm(initialObjectInitializer);

    async function handleSubmit(e) {
        e.preventDefault();
        const response = await createCalendarData({...tempObject, date: tempObject.date + 'T00:00:00'})
        setIsLoading(false);
        if (response) onOpenChanged(false);
    }

    async function handleEdit(e) {
        e.preventDefault();
        const response = await editCalendarData({
            ...tempObject, date: tempObject.date + 'T00:00:00'
        });

        setIsLoading(false);
        if (response) onOpenChanged(false);
    }

    return <Form>
        <Section>
            <Col xs={6}>
                <FormLabel>Titel:</FormLabel>
                <FormControl value={tempObject.title} onChange={(e) => onChange(e, 'title')}/>
            </Col>
            <Col xs={6}>
                <FormLabel>Datum:</FormLabel>
                <FormControl
                    value={tempObject.date}
                    type={'date'} onChange={(e) => onChange(e, 'date')}/>
            </Col>
            <Col xs={12}>
                <FormLabel>Locatie:</FormLabel>
                <FormControl value={tempObject.location} onChange={(e) => onChange(e, 'location')}/>
            </Col>
            <Col xs={12}>
                <FormLabel>Type:</FormLabel>
                <FormSelect  onChange={(e) => onChange(e, 'type')}>
                    {calendartypes?.map(ct => <option selected={tempObject.type === ct.title} value={ct.title} name={ct.title}>{ct.title}</option>)}
                </FormSelect>
            </Col>
            <Col xs={12}>
                <FormLabel>Omschrijving:</FormLabel>
                <CustomEditor initText={tempObject.description} fieldName={'description'}
                              onEditorChange={onEditorChange} disableToolbar={true}/>
            </Col>
            <Col xs={12} className={'text-end mt-2'}>
                <ButtonLoading title={"Opslagen"} isLoading={loading} onClick={(e) => {
                    setIsLoading(true);
                    taskEditing ? handleEdit(e) : handleSubmit(e)
                }}>Submit</ButtonLoading>
            </Col>
        </Section>
    </Form>


}